<div class="layout-col full" style="width: 80vw; height: 100vh">
  <div class="layout-col">
    <mat-toolbar elderTheme>
      <button mat-icon-button matDialogClose (click)="cancel()">
        <mat-icon>close</mat-icon>
      </button>

      <elder-header [header]="'positions.detail' | translate" [subheader]="'ID: ' + item.id">
      </elder-header>
    </mat-toolbar>
  </div>
  <app-work-item-content [item]="item" class="flex"></app-work-item-content>
</div>
